import { RequestStatus, WorkOrderPriority, WorkOrderStatus } from '../../interfaces/maintenance';

type ChipColor = 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';

export const WO_STATUS_COLOR: Record<WorkOrderStatus, ChipColor> = {
    OPEN: 'info', ASSIGNED: 'info', IN_PROGRESS: 'primary', ON_HOLD: 'warning',
    COMPLETED: 'success', CLOSED: 'default', CANCELLED: 'default',
};

export const WO_PRIORITY_COLOR: Record<WorkOrderPriority, ChipColor> = {
    URGENT: 'error', HIGH: 'warning', NORMAL: 'default', LOW: 'default',
};

export const REQUEST_STATUS_COLOR: Record<RequestStatus, ChipColor> = {
    SUBMITTED: 'warning', ACCEPTED: 'info', REJECTED: 'error', MERGED: 'default',
    CANCELLED: 'default', RESOLVED: 'success', CLOSED: 'default',
};

/** Flex cell for filter rows: grows, never fixed, never a lone full-width control. */
export const cell = (basis: number) => ({ flex: `1 1 ${basis}px`, maxWidth: basis + 140, minWidth: 0 });

export const fmtDateTime = (iso?: string | null): string => {
    if (!iso) return '-';
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '-' : d.toLocaleString();
};

/** Value of a datetime-local input (local wall time) -> ISO instant, or undefined when blank. */
export const localToIso = (v: string): string | undefined => {
    if (!v) return undefined;
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
};

export const fmtMinutes = (m?: number | null): string => {
    if (m === undefined || m === null) return '-';
    const h = Math.floor(m / 60);
    return h > 0 ? `${h}h ${m % 60}m` : `${m}m`;
};

export const money = (v?: number | null): string =>
    v === undefined || v === null ? '-' : Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
